import { BrandedNewTabIcon, Button, ButtonSize, Link, LinkProps, useMediaQ } from '@csp/csp-web-ui';
import { FC, ReactNode } from 'react';

type Props = LinkProps & {
  href: string;
  children?: ReactNode;
  size?: ButtonSize;
};

export const NewTabLink: FC<Props> = ({ href, children, size, ...rest }) => {
  const smDown = useMediaQ('sm', 'down');

  return (
    <Link href={href} target="_blank" {...rest}>
      <Button
        fullWidth={smDown}
        variant="outlined"
        size={size}
        endIcon={<BrandedNewTabIcon color="primary" size={size} mb={0.5} />}
        pt={0.5}
      >
        {children}
      </Button>
    </Link>
  );
};
